// removed by extract-text-webpack-plugin
module.exports = {"dimensions":"_25FnISdWoaZjiXjpFqOB6a","task":"_20Ajmyqy4ONqGb43sO1bHf","buttonEdit":"LVJV7aXyk2wYa5s0mGrDV","range":"_1y9wPL8PjNQXTlWA8bqwpe","stockRow":"aL8LDlmho4-5HkQFTh3Xv","title":"_39MpGVAGqNIeCzXCubqjeR","goal":"_2ciWONB8nc7nzIQX2VKpSd","count":"_1f7PrfZTDIS55KAoKzxqvg","green":"_2a2k9KIL4ZC5xebghkapjg","red":"C4ecXqqeTBogDlxHkk9UJ","removed":"_2LfSr-2d6eAIpxTDFJaxKd"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/Container/style.scss
// module id = 1055
// module chunks = 0